const internals = `
query internals($skip: Int, $limit: Int, $sort: sortInput, $where:internalWhereInput){
  internals(skip: $skip, limit: $limit, sort: $sort, where:$where){
    totalCount
    list{
      id
      createdAt
      name
      internalCode
      isActive
      associatedLogin{
        id
      }
      contacts{
        id
        type
        value
      }
    }
  }
}
`

const internal = `
query internal($skip: Int, $limit: Int, $sort: sortInput, $where:internalWhereInput){
  internals(skip: $skip, limit: $limit, sort: $sort, where:$where){
    totalCount
    list{
      __typename
      id
      createdAt
      englishFirstName
      englishLastName
      chineseFirstName
      chineseLastName
      internalCode
      isActive
      associatedLogin{
        id
      }
      contacts{
        id
        type
        value
      }
    }
  }
}
`

const permissionGroups = `
query readAllPermissionGroups{
  permissionGroups{
    id
    name
    description
    createdAt
    targettedPermissions{
      permission{
        id
        name
      }
      targetIds
    }
  }
}
`

const inviteInternal = `
mutation inviteInternal($clientId: String! $inviteInternalInput: inviteInternalInput!){
  inviteInternal(clientId: $clientId inviteInternalInput: $inviteInternalInput){
    id
  }
}
`

const createInternal = `
mutation createInternal($createInternalInput:createInternalInput!){
  createInternal(createInternalInput: $createInternalInput){
    status
    errors
    createdStatus{
      id
    }
  }
}
`

const assignRole = `
mutation assignRoleToLogin($loginId: String! $permissionGroupId: String!) {
  addToPermissionGroup(
    loginId: $loginId
    permissionGroupId: $permissionGroupId
  ) {
    errors
    status
  }
}
`

const updateInternal = `
mutation updateInternal($id:String! $updateInternalInput:updateInternalInput!){
  updateInternal(id:$id updateInternalInput:$updateInternalInput){
    status
    errors
  }
}
`

const addContact = `
mutation addContact($entityId:String! $contactInput:addContactInput!){
  addContact(entityId:$entityId contactInput:$contactInput){
    status
    errors
  }
}
`

const updateContact = `
mutation updateContact($entityId:String! $updateContactInput:updateContactInput!){
  updateContact(entityId:$entityId updateContactInput:$updateContactInput){
    status
    errors
  }
}
`

const deleteInternal = `
mutation deleteCustomer($id: String!){
  deleteEntity(id: $id){
    status
    errors
  }
}
`

const query = {
	internals,
	internal,
	permissionGroups
}

const mutation = {
	createInternal,
	inviteInternal,
	assignRole,
	updateInternal,
	addContact,
	updateContact,
	deleteInternal
}

export { query, mutation }
